export const tickTime = 250;
